import { useState } from 'react'
import { useDailyEvent } from '@daily-co/daily-react'
import { useRemoteSessionId } from './useRemoteSessionId'

export function usePatientConnected() {
  const { remoteSessionId } = useRemoteSessionId()
  const [isDialout, setIsDialout] = useState(false)
  const [dialoutAnswered, setDialoutAnswered] = useState(false)

  useDailyEvent('dialout-connected', () => {
    setIsDialout(true)
  })

  useDailyEvent('dialout-answered', () => {
    setDialoutAnswered(true)
  })

  useDailyEvent('dialout-stopped', () => {
    setIsDialout(false)
    setDialoutAnswered(false)
  })

  const patientConnected = isDialout ? !!remoteSessionId && dialoutAnswered : !!remoteSessionId

  return { patientConnected, dialoutAnswered }
}
